<template>
  <div class="Proposal_info" align="" style="width:80%">
    <div v-if="data">
      <div class="title" :inline="true">
        <el-form >
          <el-form-item   :label="`${$t('ProposalInfo.title')}`"  >          
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
            <a  href="/">{{$t('navBar.goback')}}</a> 
        </el-breadcrumb-item>
        <!-- <el-breadcrumb-item>
            <router-link v-bind:to="`/infoobs/`+data.id">{{$t('ObsInfo.title')}}</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
            <router-link v-bind:to="`/infotarget/`+data.id">{{$t('TargetInfo.title')}}</router-link>
        </el-breadcrumb-item> -->
      </el-breadcrumb>
      <div class="container" v-if="data">
        <el-form :inline="true" :model="ProposalInfoForm" class="search-form">

          <el-form-item  label="ID" v-if="false">
            <el-input size="mini" v-model="data.id" autocomplete="off" :disabled="true" v-if="false" ></el-input>
          </el-form-item>

          <el-form-item v-if="false"  :label="$t('proposal.obs_id')" >
            <el-input size="mini" v-model="data.obs_id" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>

          <el-form-item  v-if="false" :label="$t('proposal.schedule_id')">
            <el-input size="mini" v-model="data.schedule_id" autocomplete="off" :disabled="true"  v-if="false" ></el-input>
          </el-form-item>

          <el-form-item  v-if="false" :label="$t('proposal.tstart')">
            <el-input size="mini" v-model="data.tstart" autocomplete="off" :disabled="true"  v-if="false" ></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.tsop')">
            <el-input size="mini" v-model="data.tsop" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.start_utc')">
            <el-input size="mini" v-model="data.start_utc" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.stop_utc')">
            <el-input size="mini" v-model="data.stop_utc" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.duration')">
            <el-input size="mini" v-model="data.duration" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.pre_slew')">
            <el-input size="mini" v-model="data.pre_slew" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.post_slew')">
            <el-input size="mini" v-model="data.post_slew" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.target')">
            <el-input size="mini" v-model="data.target" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.obs_mode')">
            <el-input size="mini" v-model="data.obs_mode" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.data_mode')">
            <el-input size="mini" v-model="data.data_mode" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  :label="$t('proposal.proposal')">
            <el-input size="mini" v-model="data.proposal" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>
          <el-form-item :label="$t('proposal.observer')">
            <el-input size="mini" v-model="data.observer" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>
          <el-form-item  :label="$t('proposal.ptype')">
            <el-input size="mini"  v-model="data.ptype" autocomplete="off" :disabled="true" ></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.status')">
            <el-input size="mini" v-model="data.status" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.ra')">
            <el-input size="mini" v-model="data.ra" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.dec')">
            <el-input size="mini" v-model="data.dec" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.speed')">
            <el-input size="mini" v-model="data.speed" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.interval')">
            <el-input size="mini" v-model="data.interval" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.radius')">
            <el-input size="mini" v-model="data.radius" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.offset')">
            <el-input size="mini" v-model="data.offset" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.owner')">
            <el-input size="mini" v-model="data.owner" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>

          <!-- <template slot-scope="{row}">
            <span :title="$t(`proposal.isopen_data.${row.isopen}`)">{{row.isopen}}</span>
          </template> -->

          <el-form-item  v-if="false" :label="$t('proposal.isopen')">
            <el-input size="mini" v-model="data.isopen" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.archive_time')">
            <el-input size="mini" v-model="data.archive_time" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.release_time')">
            <el-input size="mini" v-model="data.release_time" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.open_time')">
            <el-input size="mini" v-model="data.open_time" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.l1_file_id')">
            <el-input size="mini" v-model="data.l1_file_id" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.l15_file_id')">
            <el-input size="mini" v-model="data.l15_file_id" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.l2_file_id')">
            <el-input size="mini" v-model="data.l2_file_id" autocomplete="off" :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.create_time')">
            <el-input size="mini" v-model="data.create_time" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.create_by')">
            <el-input size="mini" v-model="data.create_by" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.update_time')">
            <el-input size="mini" v-model="data.update_time" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
          <el-form-item  v-if="false" :label="$t('proposal.update_by')">
            <el-input size="mini" v-model="data.update_by" autocomplete="off"  :disabled="true"  v-if="false"></el-input>
          </el-form-item>
        </el-form>

        <el-table :data="list" @sort-change="sortChange">
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>

          <el-table-column
            prop="id"
            label="id"
            v-if="false">
          </el-table-column>  

          <el-table-column
            prop="obs_id"
            width="120"
            sortable="custom"
            :label="$t('proposal.obs_id')">
            <template slot-scope="scope">
              <span :title="$t('proposal.tip.obs_id')" >
                <router-link v-bind:to="`/infoobs/`+scope.row.id">{{scope.row.obs_id}}</router-link>
                <!-- <a :href="`/infoobs/$t{'scope.row.id}`" target="_blank" class="buttonText">{{scope.row.obs_id}}</a> -->
              </span>
            </template>
      
          </el-table-column>

          <el-table-column
            prop="proposal"
            
            :label="$t('proposal.proposal')"
            v-if="false">
            <template slot-scope="scope">
              <span :title="$t('proposal.tip.proposal')">
                <router-link v-bind:to="`/infoproposal/`+scope.row.id">{{scope.row.proposal}}</router-link>
              </span>
            </template>
          </el-table-column>  

          <el-table-column
            prop="schedule_id"
            v-if="false"
            width="120"
            sortable="custom"
            :label="$t('proposal.schedule_id')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.schedule_id')">{{row.schedule_id}}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="55"
            :label="$t('proposal.obs_mode')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.obs_mode')">{{row.obs_mode}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="target"
            sortable="custom"
            :label="$t('proposal.target')">
            <template slot-scope="scope">
              <span :title="$t('proposal.tip.target')">
                <router-link v-bind:to="`/infotarget/`+scope.row.id">{{scope.row.target}}</router-link>
              </span>
            </template>
          </el-table-column>

          <el-table-column
            prop="start_utc"
            sortable="custom"
            :label="$t('proposal.start_utc')">
          </el-table-column>

          <el-table-column
            :label="$t('proposal.tstart')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.tstart')">{{row.tstart}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="stop_utc"
            sortable="custom"
            :label="$t('proposal.stop_utc')">
          </el-table-column>

          <el-table-column
            :label="$t('proposal.tsop')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.tsop')">{{row.tsop}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="duration"
            sortable="custom"
            :label="$t('proposal.duration')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.duration')">{{row.duration}}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="58"
            :label="$t('proposal.status')">
            <template slot-scope="{row}">
              <span :title="$t('proposal.tip.status')">{{row.status}}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="65"
            :label="$t('proposal.isopen')">
            <template slot-scope="{row}">
              <span :title="$t(`proposal.isopen_data.${row.isopen}`)">{{$t(`proposal.isopen_data.${row.isopen}`)}}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('proposal.operate')"
            width="150"
            v-if="false">
            <template slot-scope="scope"  >
              <el-button
                v-show="scope.row.isApply"
                class="op-btn"
                :data-clipboard-text="scope.row"
                size="small"
                @click="apply(scope.row)">
                {{$t('proposal.apply')}} 
              </el-button>

              <el-dropdown v-show="scope.row.isDownload">
                <el-button type="primary" size="small" class="op-btn">
                  {{$t('proposal.download')}}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div :data-clipboard-text="`/download/${scope.row.id}`">
                      {{$t('proposal.copy_downlink')}}
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div :data-clipboard-text="scope.row.id">
                      {{$t('proposal.get_wget')}}
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

        </el-table>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes.sync="pageSizes"
          :page-size.sync="pageSize"
          :total="total"
          @size-change="getPData"
          @current-change="getPData">
        </el-pagination>

        <div align="right">
          <!-- <el-button size="mini" @click="chiefverno" :disabled="true"  v-if="false">拒绝(refuse)</el-button>
          <el-button size="mini" type="primary" @click="chiefverok" :disabled="true"  v-if="false">同意(OK)</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProposalInfo',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: null,
      ProposalInfoForm:{
      },
      list: [],
      currentPage: 1,
      pageSizes:[10,20, 50, 100, 200,300],
      pageSize: 10,
      total: 0,
      orderDirection: null,
      orderProp: '',
    };
  },
  created() {
    this.getData();
  },
 
  methods: {
    getData() {
      const params = {
        id : this.id,
      }
      
      axios.post('/iapi/InfoObs', params).then((res) => {
        if (res.data.errcode === 0) {
          this.data = res.data.data;
          // console.log('data',this.data);
          this.getPData();
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    getPData() {
      // console.log('getPData-data',this.data);
      const params = {
        proposal : this.data.proposal,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      }
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/ProposalObs', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
          // console.log('data',this.data);
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
    onSubmit() {
      this.getData();
      this.getPData();
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getPData();
    },
  },
};
</script>

<style scoped>

.Proposal_info{
  padding: 24px 56px;
  margin:0 auto;
}
.title {
  margin-right: 56px;
  font-size: 40px;
  color: #fff;
  font-weight: 50;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 5px;
    margin-bottom: 5px;
}
.admin-path {
  margin-bottom: 30px;
}
</style>
